import { Box, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import styles from '../AndarBahar/styles.module.css'
import FooterLinks from '../FooterLinks';
import { useLocation } from 'react-router-dom';
import GameScreen from './GameScreen';
import AndarBaharResult from './Result';
import FlipClock  from '../../FlipClock/FlipClock'
import { useDispatch } from 'react-redux';
import useCasinoBetplace from '../../../api/useCasinoBetplace';

import RoundLoader from '../../Loader/RoundLoader';

// import { useSelector } from 'react-redux';


const IconSpade = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path d="M15.4896 6.4L8.7515 0L2.01339 6.4C0.328869 8 0.328869 10.6057 2.01339 12.2057C3.67385 13.7829 6.32097 13.8057 8.00549 12.2971C7.9333 13.8286 7.35575 15.04 6.34503 16H11.1339C10.1232 15.04 9.54563 13.8057 9.47343 12.2971C11.158 13.8057 13.8291 13.7829 15.4655 12.2057C17.1741 10.5829 17.1741 8 15.4896 6.4Z" fill="url(#paint0_linear_7166_22447)" />
        <defs>
            <linearGradient id="paint0_linear_7166_22447" x1="3.85819" y1="4.64503" x2="13.147" y2="14.4222" gradientUnits="userSpaceOnUse">
                <stop stop-color="#454545" />
                <stop offset="1" />
            </linearGradient>
        </defs>
    </svg>
)

const IconClub = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path d="M12.2667 5.77483C12.0553 5.77483 11.855 5.79603 11.6659 5.81722C12.0442 5.23444 12.2667 4.5457 12.2667 3.81457C12.2667 1.70596 10.4753 0 8.26113 0C6.04694 0 4.25556 1.70596 4.25556 3.81457C4.25556 4.55629 4.47809 5.23444 4.8564 5.81722C4.65612 5.78543 4.45584 5.77483 4.25556 5.77483C2.04138 5.77483 0.25 7.48079 0.25 9.5894C0.25 11.698 2.04138 13.404 4.25556 13.404C5.613 13.404 6.80355 12.7576 7.52677 11.7828C7.57128 13.5417 6.9927 14.9298 5.86892 16H10.6311C9.51843 14.9298 8.93985 13.5417 8.97323 11.7828C9.69645 12.7576 10.887 13.404 12.2444 13.404C14.4586 13.404 16.25 11.698 16.25 9.5894C16.25 7.48079 14.4698 5.77483 12.2667 5.77483Z" fill="url(#paint0_linear_7166_22451)" />
        <defs>
            <linearGradient id="paint0_linear_7166_22451" x1="2.91737" y1="3.51682" x2="13.0832" y2="14.1928" gradientUnits="userSpaceOnUse">
                <stop stop-color="#454545" />
                <stop offset="1" />
            </linearGradient>
        </defs>
    </svg>
)

const IconDiamond = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path d="M16.75 8L8.75 16L0.75 8L8.75 0L16.75 8Z" fill="url(#paint0_linear_7166_22455)" />
        <defs>
            <linearGradient id="paint0_linear_7166_22455" x1="4.086" y1="3.99543" x2="11.9919" y2="13.219" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FE5B42" />
                <stop offset="1" stop-color="#BA0000" />
            </linearGradient>
        </defs>
    </svg>
)

const IconHeart = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path d="M14.9805 1.44C13.2878 -0.48 10.5674 -0.48 8.87468 1.44L8.25 2.14857L7.62531 1.44C5.93262 -0.48 3.21222 -0.48 1.51952 1.44C-0.173174 3.36 -0.173174 6.44571 1.51952 8.36571L8.25 16L14.9805 8.36571C16.6732 6.44571 16.6732 3.33714 14.9805 1.44Z" fill="url(#paint0_linear_7166_22459)" />
        <defs>
            <linearGradient id="paint0_linear_7166_22459" x1="3.35791" y1="-0.661257" x2="14.3732" y2="9.04996" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FE5B42" />
                <stop offset="1" stop-color="#BA0000" />
            </linearGradient>
        </defs>
    </svg>
)


const positions = ['', ''];


const playCards = [
    { value: 'A',  row: 1, betType: 'CARD_A',  expKey: 'cardA',  mainBetType: "SIDE", rate: "12" },
    { value: '2',  row: 1, betType: 'CARD_2',  expKey: 'card2',  mainBetType: "SIDE", rate: "12" },
    { value: '3',  row: 1, betType: 'CARD_3',  expKey: 'card3',  mainBetType: "SIDE", rate: "12" },
    { value: '4',  row: 1, betType: 'CARD_4',  expKey: 'card4',  mainBetType: "SIDE", rate: "12" },
    { value: '5',  row: 1, betType: 'CARD_5',  expKey: 'card5',  mainBetType: "SIDE", rate: "12" },
    { value: '6',  row: 1, betType: 'CARD_6',  expKey: 'card6',  mainBetType: "SIDE", rate: "12" },
    { value: '7',  row: 1, betType: 'CARD_7',  expKey: 'card7',  mainBetType: "SIDE", rate: "12" },
    { value: '8',  row: 1, betType: 'CARD_8',  expKey: 'card8',  mainBetType: "SIDE", rate: "12" },
    { value: '9',  row: 1, betType: 'CARD_9',  expKey: 'card9',  mainBetType: "SIDE", rate: "12" },
    { value: '10', row: 2, betType: 'CARD_10', expKey: 'card10', mainBetType: "SIDE", rate: "12" },
    { value: 'J',  row: 2, betType: 'CARD_J',  expKey: 'cardJ',  mainBetType: "SIDE", rate: "12" },
    { value: 'Q',  row: 2, betType: 'CARD_Q',  expKey: 'cardQ',  mainBetType: "SIDE", rate: "12" },
    { value: 'K',  row: 2, betType: 'CARD_K',  expKey: 'cardK',  mainBetType: "SIDE", rate: "12" },
];

const andarBaharData = [
    { value: "1.98", label: "Andar", betType: "Andar", mainBetType: "MAIN" },
    { value: "1.98", label: "Bahar", betType: "Bahar", mainBetType: "MAIN" }
];

const oddEvenData = [
    { value: "1.83", label: "Odd",  betType: "odd",  mainBetType: "SIDE" },
    { value: "2.12", label: "Even", betType: "even", mainBetType: "SIDE" }
];

// const cardsData = [
//     { value: "1.83", icon: <IconSpade /> },
//     { value: "1.83", icon: <IconClub /> },
//     { value: "1.83", icon: <IconDiamond /> },
//     { value: "2.12", icon: <IconHeart /> }
// ];


const cardsData = [
    { value: "3.85", label: 'Spades',   betType: "Spades",   expKey: 'spade',   mainBetType: "SIDE", icon: <IconSpade /> },
    { value: "3.85", label: 'Clubs',    betType: "Clubs",    expKey: 'club',    mainBetType: "SIDE", icon: <IconClub /> },
    { value: "3.85", label: 'Diamonds', betType: "Diamonds", expKey: 'diamond', mainBetType: "SIDE", icon: <IconDiamond /> },
    { value: "3.85", label: 'Hearts',   betType: "Hearts",   expKey: 'heart',   mainBetType: "SIDE", icon: <IconHeart /> }
];
const dealtCardsCache = new Map();

function AndarBahar({ onBetSelect, locked, socketData, settledData, gameId = 5,hookExposureData}) {

    const dispatch =useDispatch();
      const roundId   = socketData?.roundId;
       
 const [dealtCards, setDealtCards] = useState(() => 
        roundId && dealtCardsCache.has(roundId) ? dealtCardsCache.get(roundId) : []
    );
   
  const [animTimer, setAnimTimer] = useState(null);
const [exposureData, setExposureData] = useState(null);
 const  remainingTime = socketData?.remainingTime
const prevRoundIdRef = useRef(null);
const isLockedRef = useRef(false);



useEffect(() => {
  if (!socketData) return;

 if (socketData.roundId !== prevRoundIdRef.current) {
    prevRoundIdRef.current = socketData.roundId;
    const cached = dealtCardsCache.get(socketData.roundId) || [];
    setDealtCards(cached);  
    setExposureData(null);
}
   if (socketData.type === "CARD_DEALT") {
            setDealtCards(prev => {
                const updated = [...prev, {
                    side: socketData.side,
                    card: socketData.card,
                    winner: socketData.winner || null
                }];
               
                if (socketData.roundId) {
                    dealtCardsCache.set(socketData.roundId, updated);
                }
                return updated;
            });
        }
  if (socketData.type === "EXPOSURE_UPDATE") {
    setExposureData(socketData);
  }

}, [socketData]);
    useEffect(() => {
        if (dealtCardsCache.size > 3) {
            const keys = Array.from(dealtCardsCache.keys());
            keys.slice(0, keys.length - 3).forEach(k => dealtCardsCache.delete(k));
        }
    }, [roundId]);



useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
        setExposureData(hookExposureData);
    }
}, [hookExposureData, gameId]);

useEffect(() => {
  if (roundId) {
    setExposureData(null);
  }
}, [roundId]);

  
    const formatBetType = (rawBetType) => {
        if (!rawBetType) return ''; 
        if (gameId !== 10) return rawBetType.toUpperCase(); 

        const betTypeMap = {
  
    'Andar': 'ANDAR',
    'Bahar': 'BAHAR',

    'odd':   'ODD',
    'even':  'EVEN',

    'Spades':   'SPADES',
    'Clubs':    'CLUBS',
    'Diamonds': 'DIAMONDS',
    'Hearts':   'HEARTS',

    'Ace':   'ACE',
    'Two':   'TWO',
    'Three': 'THREE',
    'Four':  'FOUR',
    'Five':  'FIVE',
    'Six':   'SIX',
    'Seven': 'SEVEN',
    'Eight': 'EIGHT',
    'Nine':  'NINE',
    'Ten':   'TEN',
    'Jack':  'JACK',
    'Queen': 'QUEEN',
    'King':  'KING'
};

        return betTypeMap[rawBetType.toLowerCase()] || rawBetType.toUpperCase();
    };


// Inside AndarBahar component

const isBettingClosed = socketData?.bettingClosed === true || socketData?.type === "CARD_DEALT";

const isLocked = locked 
    || isBettingClosed 
    || (socketData?.remainingTime !== undefined && socketData.remainingTime <= 0);

isLockedRef.current = isLocked;

// Better handler with multiple safeguards
const handleNumberBoxClick = (value, label, positionIndex, rawBetType, mainBetType) => {
    // Multiple checks for safety
    if (isLockedRef.current) {
      
        return;
    }

    if (socketData?.remainingTime <= 0) {
     
        return;
    }

    const formattedSelection = formatBetType(rawBetType);

    const betData = {
        label: positions[positionIndex] 
            ? `${label} (${positions[positionIndex]})` 
            : label,
        odds: parseFloat(value),
        position: positions[positionIndex] || '',
        betType: mainBetType || 'SIDE',
        selection: formattedSelection,
    };

    if (onBetSelect) {
        onBetSelect(betData);
    }
};
const getExposureValue = (key) => {
  if (!exposureData) return null;
  const val = exposureData[key];
  if (val === undefined || val === 0 || val === 0.00) return null;
  return val;
};
const ExposureLabel = ({ value }) => {
  if (value === null) return null;
  return (
    <Typography sx={{
      fontSize: '11px',
      fontWeight: 600,
      color: value < 0 ? '#ff4444' : '#51ff00 ',
      textAlign: 'center',
      mt: '2px',
      lineHeight: 1,
    }}>
      {value}
    </Typography>
  );
};



    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
      
        <Box className={styles.MatchScreen_container}>
            <Box className={styles.box}>
                <Box sx={{ position: 'relative', width: '100%' }}>
                    {/* <img src={BollywoodCasinoimg} className={styles.bannerImage_container} /> */}

<GameScreen
  bettingClosed={isBettingClosed}
  socketData={socketData}
  remainingTime={socketData?.remainingTime ?? 0}
  onAnimStart={() => setAnimTimer(0)}
  onAnimEnd={() => setAnimTimer(null)}
/>
 
                    <Box >
                        <Box >
{(socketData?.remainingTime > 0 || animTimer !== null) && (
    <Box sx={{
              position: "absolute",
              bottom: "8px",
              right: "8px",
              zIndex: 10,
              pointerEvents: "none",
            }}>
        <FlipClock
            time={animTimer !== null ? 0 : (socketData?.remainingTime || 30)}
        />
    </Box>
)}
                        </Box>
                    </Box>
                </Box>


                <Box className={styles.box1}>
                    <Box className={styles.box2}>

                        {/* Andar/Bahar */}


                        <Box sx={{ width: '100% !important', alignSelf: 'stretch', marginBottom: '16px' }}>
                            <Box className={styles.extraBets_container}>
                                {andarBaharData.map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            minWidth: '98%',
                                            alignSelf: 'stretch',
                                            position: 'relative',
                                            '&:hover': {
                                                cursor: isLocked ? 'not-allowed' : 'pointer',
                                            },
                                        }}
                                    >
                                        <Typography className={styles.NumberText}>{item.value}</Typography>
                                        <Box className={`${styles.bettingOptions_btn} ${isLocked ? styles.locked : ''}`}
                                            //  onClick={() => handleNumberBoxClick(item.value, item.label, undefined)} 
                                     onClick={() => handleNumberBoxClick(item.value, item.label, 0, item.betType, item.mainBetType)}
                                            sx={{ position: 'relative' }}>
                                            <Typography className={styles.AText}>{item.label}</Typography>
                                            {isLocked && (
                                                <Box className={styles.bettinglocked_icon_container}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                    </svg>
                                                </Box>
                                                
                                            )}
                                        </Box>
                                        <ExposureLabel value={getExposureValue(item.betType === 'Andar' ? 'andarWins' : 'baharWins')} />
                                    </Box>
                                ))}
                            </Box>
                        </Box>






                        {/* Odd/Even */}

                        <Box sx={{ width: '100% !important', alignSelf: 'stretch', marginBottom: '16px' }}>
                            <Box className={styles.extraBets_container}>
                                {oddEvenData.map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            minWidth: '48%',
                                            alignSelf: 'stretch',
                                            position: 'relative',
                                            '&:hover': {
                                                cursor: isLocked ? 'not-allowed' : 'pointer',
                                            },
                                        }}
                                    >
                                        <Typography className={styles.NumberText}>{item.value}</Typography>
                                        <Box className={styles.bettingOptions_btn}
                                            // onClick={() => handleNumberBoxClick(item.value, item.label, undefined)} 
                                           onClick={() => handleNumberBoxClick(item.value, item.label, 1, item.betType, item.mainBetType)}
                                            sx={{ position: 'relative' }}>
                                            <Typography className={styles.AText}>{item.label}</Typography>
                                            {isLocked && (
                                                <Box className={styles.bettinglocked_icon_container}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                    </svg>
                                                </Box>
                                                
                                            )}
                                        </Box>
                                    <ExposureLabel value={getExposureValue(item.betType)} />
                                    </Box>
                                ))}
                            </Box>
                        </Box>



                        {/* Cards */}




                        <Box sx={{ width: '100% !important', alignSelf: 'stretch', marginBottom: '16px' }}>
                            <Box className={styles.extraBets_container}>
                                {cardsData.map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            minWidth: '22%',
                                            alignSelf: 'stretch',
                                            position: 'relative',
                                            '&:hover': {
                                                cursor: isLocked ? 'not-allowed' : 'pointer',
                                            },
                                        }}
                                    >
                                        <Typography className={styles.NoTextMid}>{item.value}</Typography>
                                        <Box className={styles.bettingOptions_btn}
                                            // onClick={() => handleNumberBoxClick(item.value, item.label)} 
                                          onClick={() => handleNumberBoxClick(item.value, item.label, 2, item.betType, item.mainBetType)}
                                            sx={{ position: 'relative' }}>
                                            <Typography className={styles.NoTextMid} sx={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', display: 'flex' }}>{item.icon}</Typography>
                                            {isLocked && (
                                                <Box className={styles.bettinglocked_icon_container}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                        <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                                    </svg>
                                                </Box>
                                                
                                                
                                            )}
                                        </Box>
                                       <ExposureLabel value={getExposureValue(item.expKey)} />
                                    </Box>
                                ))}
                            </Box>
                        </Box>



                        
                        <Box className={styles.AllCardsBox}>
                        {[1, 2].map(rowNum => (
    <Box key={rowNum} className={styles.AllCardsBoxInner}>
        {playCards.filter(c => c.row === rowNum).map((card, idx) => (

            <Box key={idx} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

          <Box className={styles.PlayCard}
        sx={{
            position: 'relative',
            justifyContent: 'center',
            '&:hover': { cursor: isLocked ? 'not-allowed' : 'pointer' },
        }}
        onClick={() => handleNumberBoxClick(card.rate, card.value, undefined, card.betType, card.mainBetType)}
    >

                <Typography className={styles.PlayCardText}>
                    {card.value}
                </Typography>

                <Box className={styles.SvgBox}>
                    <Box className={styles.SvgBoxInner}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                            <path d="M5.03191 2L2.92625 0L0.820592 2C0.294178 2.5 0.294178 3.31429 0.820592 3.81429C1.33949 4.30714 2.16671 4.31429 2.69312 3.84286C2.67056 4.32143 2.49008 4.7 2.17423 5H3.67075C3.3549 4.7 3.17442 4.31429 3.15185 3.84286C3.67827 4.31429 4.51301 4.30714 5.02439 3.81429C5.55832 3.30714 5.55832 2.5 5.03191 2Z" fill="url(#paint0_linear_7555_16757)" />
                            <defs>
                                <linearGradient id="paint0_linear_7555_16757" x1="1.39709" y1="1.45157" x2="4.29985" y2="4.50693" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#454545" />
                                    <stop offset="1" />
                                </linearGradient>
                            </defs>
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                            <path d="M5.88672 2.5L3.38672 5L0.886719 2.5L3.38672 0L5.88672 2.5Z" fill="url(#paint0_linear_7555_16758)" />
                            <defs>
                                <linearGradient id="paint0_linear_7555_16758" x1="1.92922" y1="1.24857" x2="4.39981" y2="4.13092" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#FE5B42" />
                                    <stop offset="1" stopColor="#BA0000" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </Box>

                    <Box className={styles.SvgBoxInner}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                            <path d="M4.181 1.80464C4.11493 1.80464 4.05235 1.81126 3.99324 1.81788C4.11146 1.63576 4.181 1.42053 4.181 1.19205C4.181 0.533113 3.62119 0 2.92926 0C2.23733 0 1.67752 0.533113 1.67752 1.19205C1.67752 1.42384 1.74706 1.63576 1.86528 1.81788C1.80269 1.80795 1.74011 1.80464 1.67752 1.80464C0.985587 1.80464 0.425781 2.33775 0.425781 2.99669C0.425781 3.65563 0.985587 4.18874 1.67752 4.18874C2.10172 4.18874 2.47376 3.98676 2.69977 3.68212C2.71368 4.23179 2.53287 4.66556 2.18169 5H3.66987C3.32217 4.66556 3.14136 4.23179 3.15179 3.68212C3.3778 3.98676 3.74984 4.18874 4.17404 4.18874C4.86598 4.18874 5.42578 3.65563 5.42578 2.99669C5.42578 2.33775 4.86945 1.80464 4.181 1.80464Z" fill="url(#paint0_linear_7555_16760)" />
                            <defs>
                                <linearGradient id="paint0_linear_7555_16760" x1="1.25933" y1="1.09901" x2="4.43616" y2="4.43524" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#454545" />
                                    <stop offset="1" />
                                </linearGradient>
                            </defs>
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                            <path d="M5.48999 0.45C4.96103 -0.15 4.1109 -0.15 3.58193 0.45L3.38672 0.671428L3.1915 0.45C2.66254 -0.15 1.81241 -0.15 1.28344 0.45C0.754477 1.05 0.754477 2.01429 1.28344 2.61429L3.38672 5L5.48999 2.61429C6.01896 2.01429 6.01896 1.04286 5.48999 0.45Z" fill="url(#paint0_linear_7555_16761)" />
                            <defs>
                                <linearGradient id="paint0_linear_7555_16761" x1="1.85794" y1="-0.206643" x2="5.30022" y2="2.82811" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#FE5B42" />
                                    <stop offset="1" stopColor="#BA0000" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </Box>
                </Box>

                {isLocked && (
                    <Box className={styles.bettinglocked_icon_container}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                        </svg>
                    </Box>
                )}

            </Box>

     
            <ExposureLabel value={getExposureValue(card.expKey)} />

            </Box>
        ))}
    </Box>
))}
                        </Box>

                    </Box>
                </Box>
                     <FooterLinks
    socketData={socketData}
    settledData={settledData}
    gameType="andarbahar"
/>
            </Box>

        </Box>
    
    )


}
export default AndarBahar